import clsx from 'clsx'
import { useQueryStates } from 'nuqs'
import React, { useEffect } from 'react'

import { ampli } from '@Analytics/ampli'
import SvgAngleRight from '@Assets/SVG/AngleRight'
import SVGCheck from '@Assets/SVG/Check'
import { AccordionV2, useAccordionActions } from '@Components/CMS/AccordionV2/AccordionV2'
import { getSortLabel } from '@Components/Facet/Display'
import { SVGIcon } from '@Components/Icons/SVGIcon'
import { queryParameterPage, queryParameterSorting } from '@Globals/Algolia/Shared'
import { ProductSorting } from '@Globals/Algolia/Types'
import { gtagEvent } from '@Globals/Google/GTag'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './SortingAccordion.module.scss'

export const SortingAccordion = ({
  scrollToTop,
}: {
  scrollToTop?: () => void
}) => {
  const { t } = useTranslation()
  const accordionActions = useAccordionActions()
  const [queryStates, setQueryStates] = useQueryStates({
    page: queryParameterPage,
    sorting: queryParameterSorting,
  })
  const topLinksV2 = useSplitTest('top_links_v2', 'b')

  useEffect(() => {
    const autoClose = () => {
      if (typeof document !== 'undefined') {
        const input = document.getElementById('sort-by-filter')
        if (input && 'checked' in input && input.checked) {
          input.click()
        }
      }
    }
    if (typeof document !== 'undefined') {
      document.addEventListener('click', autoClose)
    }
    return () => document.removeEventListener('click', autoClose)
  }, [])

  return (
    <AccordionV2
      backdrop
      className={clsx(styles.sortByAccordion, topLinksV2 && styles.topLinksV2)}
      id="sort-by-filter"
      ref={accordionActions}
      trigger={(
        <div className={styles.sortByTrigger}>
          <h3 className={clsx(styles.headerMobile, styles.header)}>{t('products:FILTER_SORT_BY_LABEL').replace(':', '')}</h3>
          <h3 className={clsx(styles.headerDekstop, styles.header)}>{t('products:FILTER_SORT_BY_LABEL')}</h3>
          <div className={styles.subHeaderWrapper}>
            <h3 className={styles.subHeader}>{t(getSortLabel(queryStates.sorting))}</h3>
            <SVGIcon icon={SvgAngleRight} size="16px" />
          </div>
        </div>
      )}
    >
      <div className={styles.sortByContent}>
        {Object.values(ProductSorting)
          .map(key => (
            <button
              key={key}
              className={clsx(styles.mobileSortSelectButton, key === queryStates.sorting && styles.active)}
              onClick={() => {
                try {
                  ampli.plApplySorting({
                    sorting_type: key,
                  })

                  gtagEvent('sorting_changed', {
                    sorting_type: key,
                  })
                } catch {
                  // ignore errors
                }
                setQueryStates(prev => ({ ...prev, page: 1, sorting: key }))
                accordionActions.current?.close()
                scrollToTop?.()
              }}
              type="button"
            >
              <span>{t(getSortLabel(key))}</span>
              {key === queryStates.sorting && <SVGIcon icon={SVGCheck} size="14px" />}
            </button>
          ))}
      </div>
    </AccordionV2>
  )
}
